export class Step4 {
    constructor() { }

    public getspan17 = 'form.dive_at.getspan17';
    public getspan18 = 'form.dive_at.getspan18';

}
